"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M18 10.48V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4.48l3.15 3.13c.31.32.85.09.85-.35V7.7c0-.44-.54-.67-.85-.35zM5.6 15.2l1.38-1.83c.2-.27.6-.27.8 0L9 15l2.23-2.97c.2-.27.6-.27.8 0l2.38 3.17c.25.33.01.8-.4.8H6c-.41 0-.65-.47-.4-.8"
}), 'VideoCameraBackRounded');